module.exports = __webpack_public_path__ + "img/commit.7a1a8351.png";